import React, { HTMLProps } from 'react'
import styled from 'styled-components'
import cn from 'classnames'

export type ButtonGroupPaginationOption = {
    value: number
    label: string
}

const SButtonGroup = styled.div`
    display: flex;
    font-size: 14px;
    font-weight: 400;
    justify-content: flex-end;
    gap: 20px;
    @media (max-width: 900px) {
        justify-content: space-between;
    }
`

const SButton = styled.a<{ selected: boolean }>`
    display: inline-block;
    color: ${({ selected, theme }) => (selected ? theme.font.darkestColor : theme.brandColors.CA_Blue)};
    text-decoration: ${({ selected }) => (selected ? 'underline' : 'none')};
    cursor: pointer;
    font-weight: 500;

    &:hover {
        color: ${({ theme, selected }) => (selected ? theme.font.darkestColor : theme.brandColors.CA_Blue)};
        opacity: ${({ selected }) => (selected ? 1 : 0.5)};
        text-decoration: ${({ selected }) => (selected ? 'underline' : 'none')};
    }
`

const SButtonGroupItem = styled(SButton)`
    display: flex;
    align-items: center;
`

const defaultPaginationOptions: ButtonGroupPaginationOption[] = [20, 50, 100].map((x) => ({
    label: x.toString(),
    value: x,
}))

type ButtonGroupPaginationProps = {
    value: number
    options?: ButtonGroupPaginationOption[]
    onChange: (pageSize: number) => void
} & HTMLProps<HTMLDivElement>

const ButtonGroupPagination = ({
    value,
    options = defaultPaginationOptions,
    onChange,
    className,
    ...rest
}: ButtonGroupPaginationProps): React.ReactElement => {
    return (
        <SButtonGroup className={cn(className, 'btn-group', 'TID-ButtonGroup')} {...rest}>
            {options.map((option, i) => (
                <SButtonGroupItem
                    key={`buttongroup-button-${option.value}`}
                    onClick={() => onChange(option.value)}
                    type="button"
                    selected={value === option.value}
                    data-testid={'button-' + i}
                >
                    {option.label}
                </SButtonGroupItem>
            ))}
        </SButtonGroup>
    )
}

export default ButtonGroupPagination
